// import './scrollFrame.2.js';

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
const coreInstance = new Core();

window.addEventListener("load", function () {

    $('#vxphl-ld-25-a-navigation .logo').on('click', function (e) {
        if ($('#promotion-iframe.frameActive').length <= 0) return;
        $('.fakeClick').eq(0).trigger('click');

    });

 
});
